import { createSlice } from "@reduxjs/toolkit";
import img1 from '@/assets/product/product_1.webp'
import img2 from '@/assets/product/product_2.webp'
import img3 from '@/assets/product/product_3.webp'
import img4 from '@/assets/product/product_4.webp'
import img5 from '@/assets/product/product_5.webp'
import img6 from '@/assets/product/product_6.webp'
import img7 from '@/assets/product/product_7.webp'
import img8 from '@/assets/product/product_8.webp'
import img9 from '@/assets/product/product_9.webp'







const nameSlice = createSlice({
    name: 'Product',
    initialState: {
        productList: [
            {
                id: 2,
                type: 1,//1:GPU,2:Bare Metal
                title: 'NVIDIA  H100&H200 Tensor Core GPU',
                header: ['', 'NVIDIA H100 SXM', 'NVIDIA H200 SxM¹'],
                parameter: [
                    ['FP64', '34 TFLOPS', '34 TFLOPS'],
                    ['FP64 Tensor Core', '67 TFLOPS', '67 TFLOPS'],
                    ['FP32', '67 TFLOPS', '67 TFLOPS'],
                    ['TF32 Tensor Core', '989  TFLOPs²', '989  TFLOPs²'],
                    ['BFLOAT16Tensor Core', '1,979  TFLOPs²', '1,979  TFLOPs²'],
                    ['FP16 Tensor Core', '1,979  TFLOPs²', '1,979  TFLOPs²'],
                    ['FP8 Tensor Core', '3,958 TFLOPs2', '3,958 TFLOPs2'],
                    ['INT8 Core', '3,958  TFLOPs²', '3,958  TFLOPs²'],
                    ['GPU Memory', '80GB', '141GB'],
                    ['GPU Memory Bandwith', '3.35TB/s', '4.8TB/s'],
                    ['Decoders', ['7 NVDEC', '7JPEG'], ['7 NVDEC', '7JPEG']],
                    ['Interconnect', ['NVIDIA NVLink⑧:900GB/s', 'PCle Gen5:128GB/s'], ['NVIDIA NVLink⑧:900GB/s', 'PCle Gen5:128GB/s']],
                    [['1Preliminary specifications.May be subject to chang', '2With sparsity.']]
                ],
                desc: [
                    // { title: 'NVIDIA H100 Tensor Core GPU', content: 'Powered by the NVIDIA Hopper™ architecture, the H100 GPU integrates fourth-generation Tensor Cores and a Transformer Engine utilizing FP8 precision. It delivers up to 4x faster training for GPT-3 (175B) models compared to its predecessor, setting a new standard for AI performance.' },
                    // { title: 'NVIDIA H200 Tensor Core GPU', content: "NVIDIA H200 Tensor Core GPU The NVIDIA H200 is the first GPU to feature 141 GB of HBM3e memory, with an impressive bandwidth of 4.8 TB/s. This nearly doubles the memory capacity and provides 1.4x higher memory bandwidth than the H100 GPU. The enhanced memory capacity and speed of the H200 accelerate generative AI, large language models, and HPC workloads with improved energy efficiency and reduced total cost of ownership." },
                    { title: 'NVIDIA H100', content: 'Electron Gateway simplifies access to high-performance computing, offering cost-effective solutions tailored to your needs. Within minutes, you can deploy virtual machines equipped with fractional, single, or multiple NVIDIA GPUs. Reach out to us for customized contract terms and flexible payment plans.' },
  
                ],
                img:img1
            },
            {
                id: 3,
                type: 1,
                title: 'NVIDIA GH200',
                header: [],
                parameter: [
                    ['Grace CPU Cores', '72 Cores'],
                    ['CPU LPDDR5X bandwidth', 'Up to 500 GB/s'],
                    ['GPU HBM bandwidth', '4TB/s HBM3'],
                    ['NVLink-C2C bandwidth', '900GB/s total,450GB/s per direction'],
                    ['CPULPDDR5X capacity', '480GB'],
                    ['GPU HBM capacity', '96GB HBM3'],

                ],
                // desc: [{ title: 'NVIDIA GH200', content: 'The NVIDIA GH200 is a pioneering innovation, combining a high-bandwidth connection between the Grace CPU and Hopper GPU. This design marks a new era in accelerated computing and generative AI, offering up to 10x higher performance for data-intensive applications. It empowers scientists and researchers to tackle the world’s most complex challenges with unprecedented efficiency.' }]
                desc: [{ title: 'NVIDIA HGX A100', content: 'Achieving unmatched acceleration for top AI, data analytics, and HPC workloads, the system features eight A100 80 GB SXM GPUs with 600 Gbps NVLink. Pricing for the NVIDIA HGX A100 is based on a 36-month, fully prepaid reserved instance. Hourly rates are calculated on a 730-hour month. Contact us for alternative contract terms and payment options.' }],
                img:img2

            },
            {
                id: 4,
                type: 1,
                title: 'NVIDIA A100',
                header: ['', 'A10080GB PCle', 'A10080GB SXM'],
                parameter: [
                    ['FP64', '9.7 TFLOPS'],
                    ['FP64 Tensor Core', '19.5 TFLOPS'],
                    ['FP32', '19.5 TFLOPS'],
                    ['Tensor Float 32(TF32)', '156 TFLOPS|312 TFLOPS*'],
                    ['BFLOAT16 Tensor Core', '312 TFLOPS|624 TFLOPS*'],
                    ['FP16 Tensor Core', '312 TFLOPS|624 TFLOPS*'],
                    ['INT8 Tensor Core', '312 TFLOPS|624 TFLOPS*'],
                    ['GPU Memory', '80GB HBM2e', '80GB HBM2e'],
                    ['GPU Memory Bandwidth', '1,935 GB/s', '2,039 GB/s'],
                    ['Max Thermal Design Power(TDP)', '300W', '400W**'],
                    ['Multi-Instance GPU', 'Up to 7 MIGs@10GB', 'Upto 7 MIGs @10GB'],
                    ['Form Factor', 'PCle Dual-slot air-cooled or single-slot liquid-cooled', 'SXM'],
                    ['Interconnect', 'NVIDIA⑧NVLink⑧Bridge for 2 GPUs:600 GB/s**PCle Gen4:64 GB/s', ['NVLink:600 GB/s', 'PCle Gen4:64 GB/s']],
                    ['Server Options', 'Partner and NVIDIA-Certified SystemsTM with 1-8 GPUs', 'NVIDIA HGXTM A100-Partner and NVIDIA-Certified Systems with 4,8,or 16 GPUs NVIDIA DGXT"A100 with 8 GPUs'],
                ],
                // desc: [{ title: 'NVIDIA A100', content: 'Leverage the power of the NVIDIA A100 to build, train, and deploy machine learning models on demand with Vultr Cloud GPU. Scale your workloads by provisioning fractions of a single A100 on a VM, or utilize multiple A100 GPUs on bare metal servers for maximum performance.' }]

            },
            {
                id: 5,
                type: 1,
                title: 'NVIDIA L40S',
                header: [],
                parameter: [
                    ['FP32', '91.6 teraFLOPS'],
                    ['TF32 Tensor Core', '366 teraFLOPS*'],
                    ['FP16', '733 teraFLOPS*'],
                    ['FP8', '1,466 teraFLOPS*'],
                    ['RT Core Performance', '212 teraFLOPS*'],
                    ['Max Power Consumption', '350W'],
                    ['*With Sparsity'],
                ],
                desc: [{ title: 'NVIDIA L40S', content: 'The NVIDIA L40S GPU delivers powerful AI computation combined with leading graphics and media acceleration capabilities. It is engineered to support the next generation of data center workloads, including generative AI, large language model inference and training, as well as 3D graphics, rendering, and video processing.' }]

            },
            {
                id: 6,
                type: 1,
                title: 'NVIDIA A40',
                header: [],
                parameter: [
                    ['GPU   Memory', '48 GB GDDR6 with error-correcting code (ECC)'],
                    ['GPU Memory Bandwidth', '696 GB/s'],
                    ['Interconnect', ['NVIDIA NVLink 112.5 GB/s (bidirectional) ', 'PCle Gen4:64GB/s']],
                    ['NVLink', '2-way low profile(2-slot'],
                    ['Display Ports', '3x DisplayPort 1.4*'],
                    ['Max Power Consumption', '300 W'],
                    ['Form Factor', '4.4"(H)x10.5"(L)Dual Slot'],
                    ['Thermal', 'Passive'],
                    ['VGPU Sofware Support', [
                        'NVIDIAVirtual PC',
                        'NVIDIA Virtual Applications',
                        'NVIDIA RTX Virtual Workstation',
                        'NVIDIAVirtual ComputeServer',
                        'NVIDIA AI Enterprise',
                    ]],
                    ['vGPU Profiles Supported', 'SeetheVirtual GPU Licensing Guide'],
                    ['NVENC|NVDEC', '1x|2x(includes AV1 decode)'],
                    ['Secure and Measured Boot with Hardware Root of Trust', 'Yes (optional)'],
                    ['NEBS Ready', 'Level 3'],
                    ['Power Connector', '8-pin CPU'],
                ],
                desc: [{ title: 'NVIDIA A40', content: 'Accelerate your visual effects projects with the NVIDIA A40, available on demand with Vultr Cloud GPU. Optimize costs and performance by provisioning fractions of a single A40 on a VM or multiple A40 GPUs on bare metal servers, bringing your VFX visions to life faster and more efficiently.' }]

            },
            {
                id: 7,
                type: 1,
                title: 'NVIDIA A16',
                header: [],
                parameter: [
                    ['GPU Memory', '4x16GB GDDR6 with error-correcting code(ECC)'],
                    ['GPU Memory Bandwidth', '4x 200 GB/s'],
                    ['Max power consumption', '4x16GB GDDR6 with error-correcting code(ECC)'],
                    ['Interconnect', 'PCI Express Gen 4x16'],
                    ['Form factor', 'Full height,full length (FHFL)dual slot'],
                    ['Thermal', 'Passive'],
                    ['vGPU Software Support', [
                        'NVIDIA Virtual PC (vPC)',
                        'NVIDIA Virtual Applications (vApps)',     
                        'NVIDIA RTX Workstation(vWS)',
                        'NVIDIA AI Enterprise',
                    ]],
                    ['vGPU Profiles Supported', [
                        'See the Virtual GPU Licensing Guide',
                       ' Seethe NVIDIA AI Enterprise Licensing Guide'
                    ]],
                    ['NVENC|NVDEC', '4x|8x(includes AV1 decode)'],
                    ['Secure and measured boot with hardware root of trust', 'Yes (optional)'],
                    ['NEBS Ready', 'Level 3'],
                    ['Power Connector', '8-pin CPU'],
                ],
                desc: [{ title: 'NVIDIA A16', content: 'The NVIDIA A16 GPU on Vultr provides powerful, cost-efficient computing solutions for virtual desktop infrastructure (VDI), video transcoding, and AI inference. Deploy fractions of a single A16 on a VM, or scale up with multiple A16 GPUs on bare metal servers to address a broad range of computing needs.' }]

            },
            {
                id: 8,
                type: 2,
                title: 'Bare Metal',
                header: ['Function', 'Bare Metal', 'Traditional Physical Cloud'],
                parameter: [
                    ['Internal Network Bandwidth', '25G', '10G/25G'],
                    ['Storage IOPS', '25G', '167000'],
                    ['Direct Connect for Internal Network', 'Yes', 'No'],
                    ['No Need for Installation', 'Yes', 'No'],
                    ['Delivery Time', '5 minutes', '30 minutes'],
                    ['Disk Medium', 'Rssd Cloud Disk', 'Local Disk'],
                    ['Disk Capacity', 'Supports up to 32T * 20, can be expanded at any time', 'Does not support expansion'],
                    ['Disk Expansion', 'Yes', 'No'],
                    ['Cold Migration in Case of Failure', 'Yes', 'No'],
                    ['Data Backup', 'Cluster Triple Replication', 'Local RAID'],
                    ['Virtualization Layer', 'Yes, None', 'None'],
                    ['Hot Migration', 'No', 'No'],
                    ['Data Ark', 'Supported', 'Not Supported'],
                ],
                desc: [{ title: 'Fully automated dedicated servers with zero authorization layer', content: 'Bare Metal Servers provide cloud-like flexibility with high-performance computing and secure physical isolation, comparable to traditional physical servers. They enable rapid deployment, disk scalability, and failover capabilities, offering fast-growing enterprises a solution for quick deployment and flexible expansion.' }]

            },
        ],
        productNewList:[
            {
                id: 2,
                type: 1,//1:GPU,2:Bare Metal
                title: 'NVIDIA  H100&H200 Tensor Core GPU',
                header: ['', 'NVIDIA H100 SXM', 'NVIDIA H200 SxM¹'],
                desc: [
                    { title: 'NVIDIA H100', content: 'Tailored for AI and HPC tasks, the system includes fourth-generation Tensor Cores and the Transformer Engine with FP8 precision for enhanced performance. The NVIDIA H100 monthly rate below is based on a 36-month, fully prepaid reserved instance contract. Hourly pricing assumes 730 hours per month. Contact us to discuss alternative contract durations and payment plans.' },
                ],
                img:img1
            },
            {
                id: 3,
                type: 1,
                title: 'NVIDIA HGX A100',
                header: [],
                desc: [{ title: 'NVIDIA HGX A100', content: 'Achieving unmatched acceleration for top AI, data analytics, and HPC workloads, the system features eight A100 80 GB SXM GPUs with 600 Gbps NVLink. Pricing for the NVIDIA HGX A100 is based on a 36-month, fully prepaid reserved instance. Hourly rates are calculated on a 730-hour month. Contact us for alternative contract terms and payment options.' }],
                img:img2

            },
            {
                id: 4,
                type: 1,
                title: 'NVIDIA A100 PCIe',
                header: [],
                desc: [{ title: 'NVIDIA A100 PCIe', content: 'Providing unparalleled acceleration for leading AI, data analytics, and HPC applications worldwide.' }],
                img:img3
            },
            {
                id:5,
                type: 1,
                title: 'NVIDIA A40',
                header: [],
                desc: [{ title: 'NVIDIA A40', content: 'Integrating high-performance graphics with robust computing and AI capabilities to address contemporary design, creative, and scientific challenges.' }],
                img:img4
            },
            {
                id:6,
                type: 1,
                title: 'NVIDIA A16',
                header: [],
                desc: [{ title: 'NVIDIA A16', content: 'Providing virtual desktops and workstations with the power and performance needed to handle any project from any location.' }],
                img:img5
            },
            {
                id:7,
                type: 1,
                title: '',
                header: [],
                desc: [{ title: '', content: '' }],
            },
            {
                id:8,
                type: 2,
                title: 'Bare Metal',
                header: [],          
                desc: [{ title: 'Bare Metal', 
                content: 'Electron Gateway Bare Metal offers unmediated access to physical hardware, eliminating the need for a virtualization layer. You manage a dedicated physical server while benefiting from Electron Gateway\'s automation and orchestration. Each Bare Metal server is single-tenant, guaranteeing that only you can access its resources. GPU pricing for Bare Metal is provided on a per-card, per-hour basis. Please contact us for more information.'
               }],
            },
            {
                id: 9,
                type: 1,
                title: '',
                header: ['', '', ''],
                desc: [
                    { 
                    title: 'NVIDIA RTX Pro 6000', 
                    title2: '(Blackwell Server Edition)',
                    content: 'Purpose-built for next-generation AI, rendering, and simulation workloads. Powered by the NVIDIA Blackwell architecture, it combines ultra-fast 96GB GDDR7 ECC memory and fifth-generation Tensor Cores to deliver unmatched performance and energy efficiency for enterprise-grade compute environments.' },
                ],
                img:img6
            },
             {
                id: 10,
                type: 1,
                title: '',
                header: ['', '', ''],
                desc: [
                    { title: 'NVIDIA H200', 
                    content: 'Tailored for next-generation AI and HPC workloads, the NVIDIA H200 offers increased memory bandwidth and capacity over the H100, enabling faster large model training and inference.' },
                ],
                img:img7
            },
             {
                id: 11,
                type: 1,
                title: '',
                header: ['', '', ''],
                desc: [
                    { title: 'NVIDIA B200', 
                    content: 'Built on the Blackwell architecture, the B200 delivers breakthrough performance and efficiency for foundation models, generative AI, and advanced scientific computing.' },
                ],
                img:img8
            },
             {
                id: 12,
                type: 1,
                title: '',
                header: ['', '', ''],
                desc: [
                    { title: 'NVIDIA B300', 
                    content: 'The NVIDIA B300 represents the next frontier in AI acceleration, with ultra-high bandwidth memory and advanced interconnects, ideal for large-scale training clusters.' },
                ],
                img:img9
            },                       
        ],
            },
    reducers: {

        changeState(state, { payload }) {
            console.log('jinlai le', payload)
            state.state = payload
        }
    }
})
export const getters = (state) => {
    console.log('++++++++++++', state)
    return state.Product
}
export const { changeState } = nameSlice.actions
export default nameSlice.reducer
